import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Container, TextField } from '@mui/material';



const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 400,
  width: "80%",
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};



function Footer({
  employeeCode, employeeCodeIsValid, hasRegisteredShifts, pastDeadLine, workHourValidationIsOK, weekendValidationIsOK, 
  paidLeaveCountIsOK, shiftSubmitPassword, handleSubmitRequstShiftData, setPasswordPopupOpen}) {

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const handleOpen = () => {
    if (!shiftSubmitPassword || shiftSubmitPassword === "") {
      setPasswordPopupOpen(true);
    } else {
      setOpen(true);
    }
  }

  const [ submitAvailable, setSubmitAvailable ] = useState(false);

  const handleChangeForPassword = (e) => {
    const inputtedPassword = e.target.value;
    if (
      (inputtedPassword === shiftSubmitPassword) ||
      (employeeCode.includes("A") && inputtedPassword === "dz-shift-sp") ||
      (employeeCode.includes("B") && inputtedPassword === "dz-tc-shift") ||
      (employeeCode.includes("S") && inputtedPassword === "sd-dz-shift") ||
      (employeeCode.includes("T") && inputtedPassword === "dz-shift_tk") ||
      (employeeCode.includes("C") && inputtedPassword === "dz-shift_fk")
    ) {
      setSubmitAvailable(true);
    } else {
      setSubmitAvailable(false);
    }
  }

  const handleSubmit = async () => {
    try {
      await handleSubmitRequstShiftData();
      handleClose();
      alert("希望シフトの登録が完了しました。")
    } catch (error) {
      alert("データの保存に失敗しました。時間をおいて再度試すか、管理者へ問い合わせてください。")
    }
  }

  return (
    <div>
        <Container sx={{width: "100%", display: "flex", justifyContent: "center", my: 3}}>
            <Button 
                disabled={!employeeCodeIsValid || !hasRegisteredShifts || pastDeadLine}
                variant="contained"
                sx={{ 
                  width: "150px", 
                  backgroundColor: "#4A90E2", 
                  color: "white", 
                  padding: "10px 15px" 
                  }}
                onClick={handleOpen}
            >
                登録
            </Button>
        </Container>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
        <Box sx={style}>
            { !workHourValidationIsOK && (
              <Typography id="modal-validation-text1" variant="p" component="h5" color="red">
                月間稼働時間に達していません、修正してください。<br/>
              </Typography>
            ) }
            { !weekendValidationIsOK && (
              <Typography id="modal-validation-text2" variant="p" component="h5" color="red">
                土日出勤回数が足りません、修正してください。<br/>
              </Typography>
            ) }
            { !paidLeaveCountIsOK && (
              <Typography id="modal-validation-text2" variant="p" component="h5" color="red">
                有給選択は3日までです、修正してください。<br/>
              </Typography>
            ) }
            { workHourValidationIsOK && weekendValidationIsOK && paidLeaveCountIsOK && (
              <>
                <Typography id="modal-modal-title" variant="p" component="h5">
                    希望シフトを登録します。<br/>
                    パスワードを入力して「OK」ボタンを押してください。
                    <Typography fontSize={12}>
                      パスワードを忘れた場合は管理者へ問い合わせてください。
                    </Typography>
                </Typography>
                <TextField
                  id="password-input" 
                  label="Password"
                  type="password"
                  size='small'
                  sx={{
                      my:2
                  }}
                  onChange={handleChangeForPassword}
                />

                <Container 
                    sx={{
                        width: "100%", 
                        display: "flex", 
                        justifyContent: "space-between", 
                        my: 1
                    }}
                >
                    <Button 
                        disabled={!submitAvailable}
                        variant="outlined"
                        sx={{
                            width: "150px"
                        }}
                        onClick={handleSubmit}
                    >
                        OK
                    </Button>
                    <Button
                        color='error'
                        variant="outlined"
                        sx={{
                            width: "150px"
                        }}
                        onClick={handleClose}
                    >
                        キャンセル
                    </Button>
                </Container>
              </>
            )}
        </Box>
      </Modal>
    </div>
  );
}


export default Footer;